import { render } from "./ArticleEditor.vue.js?vue&type=template&id=137d6a68&scoped=true!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ArticleEditor.vue?vue&type=template&id=137d6a68&scoped=true"
import script from "./ArticleEditor.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ArticleEditor.vue?vue&type=script&lang=js"
export * from "./ArticleEditor.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ArticleEditor.vue?vue&type=script&lang=js"

import "./ArticleEditor.vue.scss?vue&type=style&index=0&id=137d6a68&lang=scss&scoped=true!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ArticleEditor.vue?vue&type=style&index=0&id=137d6a68&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-137d6a68"],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/edit-article-page/elements/ArticleEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "137d6a68"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('137d6a68', __exports__)) {
    api.reload('137d6a68', __exports__)
  }
  
  module.hot.accept("./ArticleEditor.vue.js?vue&type=template&id=137d6a68&scoped=true!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ArticleEditor.vue?vue&type=template&id=137d6a68&scoped=true", () => {
    api.rerender('137d6a68', render)
  })

}


export default __exports__